var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import * as SayIcons from "./icons";
var SayIcon = function (_a) {
    var name = _a.name, _b = _a.color, color = _b === void 0 ? "black" : _b, _c = _a.size, size = _c === void 0 ? "24" : _c;
    var IconSvg = SayIcons[name];
    var iconProps = {
        color: color,
        size: size,
    };
    return _jsx(IconSvg, __assign({ "data-testid": "say-icon-".concat(name) }, iconProps));
};
export default SayIcon;
